import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["csvUpload", "select"]
  static values = { columnsByUpload: Object }

  refresh() {
    const options = this.columnsByUploadValue[this.csvUploadTarget.value] || []

    this.selectTargets.forEach((select) => this.repopulate(select, options, select.value))
  }

  repopulate(select, options, previousValue) {
    select.innerHTML = ""
    select.appendChild(new Option("", ""))

    options.forEach(([label, value]) => {
      const option = new Option(label, value)
      option.selected = value === previousValue
      select.appendChild(option)
    })
  }
}
